module.exports = __webpack_public_path__ + "img/account_large.f1412044.png";